/* Kamakazi theme — vanilla ports of the React interactivity.
   Re-runs on Shopify's section render events so the theme editor stays live. */
(function () {
  "use strict";

  /* ---- Mobile menu (from site-header.tsx useState) ---- */
  function initHeader(root) {
    var header = root.querySelector("[data-site-header]");
    if (!header || header.dataset.bound) return;
    header.dataset.bound = "1";

    var toggle = header.querySelector("[data-nav-toggle]");
    var menu = header.querySelector("[data-nav-menu]");
    var bar1 = header.querySelector('[data-bar="1"]');
    var bar2 = header.querySelector('[data-bar="2"]');
    var bar3 = header.querySelector('[data-bar="3"]');
    var open = false;

    /* Nav links/toggle are omitted from the DOM entirely while the store is
       closed (only the logo remains), so nothing here can be assumed present. */
    if (!toggle || !menu || !bar1 || !bar2 || !bar3) return;

    function render() {
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      menu.classList.toggle("hidden", !open);
      bar1.classList.toggle("translate-y-2", open);
      bar1.classList.toggle("rotate-45", open);
      bar2.classList.toggle("opacity-0", open);
      bar3.classList.toggle("-translate-y-2", open);
      bar3.classList.toggle("-rotate-45", open);
    }

    toggle.addEventListener("click", function () { open = !open; render(); });
    header.querySelectorAll("[data-nav-close]").forEach(function (el) {
      el.addEventListener("click", function () { open = false; render(); });
    });
  }

  /* ---- Masonry gallery (from work-gallery.tsx) ----
     Three contiguous, height-balanced flex columns so a hover-scaled tile can
     overflow without being clipped by a CSS multi-column fragmentation box. */
  function initGallery(root) {
    root.querySelectorAll("[data-gallery]").forEach(function (gallery) {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = "1";

      var COLS = 3;
      var tiles = Array.prototype.slice.call(gallery.querySelectorAll("[data-tile]"));
      var ratios = tiles.map(function (t) { return parseFloat(t.dataset.ratio) || 1; });
      var total = ratios.reduce(function (a, b) { return a + b; }, 0);
      var target = total / COLS;

      var cols = [];
      for (var c = 0; c < COLS; c++) {
        var div = document.createElement("div");
        div.className = "flex flex-1 flex-col gap-2 sm:gap-4";
        cols.push(div);
      }

      var col = 0, acc = 0;
      tiles.forEach(function (tile, i) {
        cols[col].appendChild(tile);
        acc += ratios[i];
        if (col < COLS - 1 && acc >= target * (col + 1)) col += 1;
      });

      gallery.innerHTML = "";
      cols.forEach(function (d) { gallery.appendChild(d); });
    });
  }

  /* ---- Artifact viewer (from artifact-viewer.tsx) ----
     Fixed-height stage; arrows + counter only when >1 view. */
  function initViewers(root) {
    root.querySelectorAll("[data-viewer]").forEach(function (viewer) {
      if (viewer.dataset.bound) return;
      viewer.dataset.bound = "1";

      var views = Array.prototype.slice.call(viewer.querySelectorAll("[data-view]"));
      if (views.length < 2) return;
      var counter = viewer.querySelector("[data-counter]");
      var index = 0;

      function show(i) {
        index = (i + views.length) % views.length;
        views.forEach(function (v, n) {
          var hidden = n !== index;
          v.classList.toggle("opacity-0", hidden);
          v.classList.toggle("pointer-events-none", hidden);
          if (hidden) v.setAttribute("aria-hidden", "true");
          else v.removeAttribute("aria-hidden");
        });
        if (counter) counter.textContent = "View " + (index + 1) + " of " + views.length;
      }

      viewer.querySelectorAll("[data-prev]").forEach(function (b) {
        b.addEventListener("click", function () { show(index - 1); });
      });
      viewer.querySelectorAll("[data-next]").forEach(function (b) {
        b.addEventListener("click", function () { show(index + 1); });
      });
      // Let the variant picker jump the stage to a variant's image, in sync.
      viewer.showView = show;
      show(0);
    });
  }

  /* ---- Variant picker (product page size/option selector) ---- */
  function initVariantPicker(root) {
    root.querySelectorAll("[data-product-variants]").forEach(function (script) {
      var form = script.closest("form");
      if (!form || form.dataset.variantBound) return;
      form.dataset.variantBound = "1";

      var variants = JSON.parse(script.textContent);
      var section = form.closest("section");
      var idInput = form.querySelector("[data-variant-id]");
      var priceEl = section.querySelector("[data-product-price]");
      var addBtn = form.querySelector("[data-add-to-cart]");
      var viewer = section.querySelector("[data-viewer]");

      function formatMoney(cents) {
        var n = cents / 100;
        return "$" + (n === Math.floor(n) ? Math.round(n) : n.toFixed(2));
      }

      function updateVariant() {
        var selected = Array.prototype.slice
          .call(form.querySelectorAll("[data-variant-option]:checked"))
          .map(function (r) { return r.value; });

        var variant = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (selected.every(function (val, idx) { return v["option" + (idx + 1)] === val; })) {
            variant = v;
            break;
          }
        }
        if (!variant) return;

        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? "Add to Cart" : "Sold Out";
        }
        // Show the picked variant's image (e.g. its color) if it has one assigned.
        if (viewer && viewer.showView && variant.featured_image) {
          viewer.showView(variant.featured_image.position - 1);
        }
      }

      form.addEventListener("change", function (e) {
        if ("variantOption" in e.target.dataset) updateVariant();
      });
    });
  }

  /* ---- First-visit newsletter popup (newsletter-popup.liquid) ---- */
  function initNewsletterPopup(root) {
    root.querySelectorAll("[data-newsletter-popup]").forEach(function (popup) {
      if (popup.dataset.bound) return;
      popup.dataset.bound = "1";

      var STORAGE_KEY = "newsletterPopupSeen";
      var SUPPRESS_MS = 30 * 24 * 60 * 60 * 1000; // re-prompt 30 days after dismissal
      var editor = window.Shopify && window.Shopify.designMode;
      var posted = !!popup.querySelector('[role="status"]');
      var lastFocused = null;

      var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
      function focusables() {
        return Array.prototype.slice.call(popup.querySelectorAll(FOCUSABLE));
      }

      function open() {
        lastFocused = document.activeElement;
        popup.classList.remove("hidden");
        popup.classList.add("flex");
        // Store an expiry timestamp so it stays hidden for 30 days, then returns.
        try { localStorage.setItem(STORAGE_KEY, String(Date.now() + SUPPRESS_MS)); } catch (e) {}
        var first = focusables()[0];
        if (first) first.focus();
      }
      function close() {
        popup.classList.add("hidden");
        popup.classList.remove("flex");
        // Return focus to wherever it was before the dialog opened (WCAG 2.4.3).
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }

      popup.querySelectorAll("[data-newsletter-close], [data-newsletter-overlay]").forEach(function (el) {
        el.addEventListener("click", close);
      });

      document.addEventListener("keydown", function (e) {
        if (popup.classList.contains("hidden")) return;
        if (e.key === "Escape") { close(); return; }
        // Trap Tab focus inside the open dialog (ARIA modal dialog pattern).
        if (e.key === "Tab") {
          var items = focusables();
          if (!items.length) return;
          var firstEl = items[0];
          var lastEl = items[items.length - 1];
          if (e.shiftKey && document.activeElement === firstEl) {
            e.preventDefault();
            lastEl.focus();
          } else if (!e.shiftKey && document.activeElement === lastEl) {
            e.preventDefault();
            firstEl.focus();
          }
        }
      });

      var suppressed = false;
      try {
        var until = parseInt(localStorage.getItem(STORAGE_KEY), 10);
        suppressed = until && Date.now() < until;
      } catch (e) {}

      // Always show in the theme editor or after a successful submit (to show the
      // thank-you); otherwise only once per 30-day window, after a short delay.
      if (editor || posted) {
        open();
      } else if (!suppressed) {
        var delay = parseInt(popup.dataset.delay, 10) || 800;
        setTimeout(open, delay);
      }
    });
  }

  function initAll(root) {
    initHeader(root);
    initGallery(root);
    initViewers(root);
    initVariantPicker(root);
    initNewsletterPopup(root);
  }

  document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  // Theme editor: re-init when a section is re-rendered.
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
